import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import ProductImageDecoratedAdornment from '../ProductImageDecoratedAdornment';
var useStyles = makeStyles(function () {
  return (
    /* theme */
    {
      root: {}
    }
  );
}, {
  name: 'SxComProductImageDecoratedAdornmentPercent'
});

function ProductImageDecoratedAdornmentPercent(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      pFontSize = _ref.fontSize,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["classes", "className", "fontSize", "size"]);

  var classes = useStyles({
    classes: pClasses
  });
  var fontSize = React.useMemo(function () {
    if (pFontSize) return pFontSize;
    var strFSize = {
      normal: 14,
      small: 10,
      large: 20
    }[size];
    if (strFSize) return strFSize;
    return 10;
  }, [pFontSize, size]);
  return /*#__PURE__*/React.createElement(ProductImageDecoratedAdornment, _extends({}, rest, {
    className: clsx(classes.root, className),
    size: size,
    fontSize: fontSize
  }));
}

ProductImageDecoratedAdornmentPercent.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string
  }),
  className: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto', 'inherit'])]),
  size: PropTypes.oneOfType([PropTypes.oneOf(['normal', 'small', 'large']), PropTypes.number])
};
ProductImageDecoratedAdornmentPercent.defaultProps = {
  classes: undefined,
  className: undefined,
  fontSize: undefined,
  size: 'small'
};
export default ProductImageDecoratedAdornmentPercent;